import { useMutation, useQueryClient } from "react-query";

import { api } from "../../utils";
import { useAuth } from "../useAuth";

export interface IUpdateAssetsParameters {
    position: number;
    header?: string;
    description?: string;
    altText?: string;
}

export interface IUpdateAssetInput {
    assetId: string;
    parameters: IUpdateAssetsParameters;
}

export const useUpdateAsset = (queryKey: string[]) => {
    const auth = useAuth();
    const queryClient = useQueryClient();

    return useMutation(
        async ({ assetId, parameters }: IUpdateAssetInput) => {
            if (!auth.token) {
                throw new Error(
                    "Cannot update asset without authorization token.",
                );
            }

            return await api.Asset.updateById(assetId, auth.token, parameters);
        },
        {
            onSuccess: () => {
                queryClient.invalidateQueries(queryKey);
            },
        },
    );
};
